import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Errored from '../core/Errored';
import EventBar from '../core/EventBar';
import EventProvider from '../core/providers/EventProvider';
import ProjectProvider from '../core/providers/ProjectProvider';
import { processHashLocation } from '../core/utils/utils';
import GS from '../grafsync/grafsync';
import DatasetData from './DatasetData';
import DatasetEditorContainer from './DatasetEditorContainer';


class DataManager extends Component {

  constructor(props) {
    super(props);
    const initState = DataManager.computeState(props);
    this.state = Object.assign(
      {
        viewValue: 1
      }, initState);
  }

  static getDerivedStateFromProps(props) {
    return DataManager.computeState(props);
  }

  static computeState(props) {
    const paramsMap = processHashLocation(props.location);
    const datasetIRI = paramsMap.get("dataset");
    let isErrored = !datasetIRI || datasetIRI === "";
    try {
      const projectData = GS.data(props.id, props.graph);
      if (!projectData.hasComponent.includes(datasetIRI)) isErrored = true;
    }
    catch (e) {
      isErrored = true;
    }
    return {
      datasetIRI,
      isErrored
    };
  }

  toggleDetail = (value) => this.setState({ viewValue: value });

  render() {

    const { viewValue, datasetIRI, isErrored } = this.state;
    const { project, graph, entitlements, projectUsers, ontologyProjects, data } = this.props;

    if (isErrored) return <Errored data={{ message: "An invalid dataset IRI has been supplied" }} />;

    return (
      <ProjectProvider value={this.props.data}>
        <EventProvider>
          <EventBar defaultLang={data.defaultLang} />
        </EventProvider>
        {
          viewValue === 0 ?
            <DatasetData
              projectIRI={project}
              graph={graph}
              entitlements={entitlements}
              toggleDetail={this.toggleDetail}
              id={datasetIRI} />
            :
            <DatasetEditorContainer
              key={datasetIRI}
              entitlements={entitlements}
              expectedTypes={["Dataset"]}
              project={project}
              ontologyProjects={ontologyProjects}
              location={this.props.location}
              projectUsers={projectUsers}
              toggleDetail={this.toggleDetail}
              graph={graph}
              id={datasetIRI}
              defaultLang={this.props.data.defaultLang} />
        }
      </ProjectProvider>
    );
  }
}

DataManager.propTypes = {
  entitlements: PropTypes.array,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  projectUsers: PropTypes.array,
  ontologyProjects: PropTypes.array,
  project: PropTypes.string.isRequired
};

export default withRouter(DataManager);
